import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'

export interface ConfirmDeleteDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  message: string
}

export const ConfirmDeleteDialog: FC<ConfirmDeleteDialogProps> = ({ open, onClose, onConfirm, title, message }) => {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('general.button.cancel')}</Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          {t('general.button.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
